module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("FOREWORD")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS IS THE STORY")]), _vm._v(" of a little lone burro who lived in the Grand Canyon of Arizona.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An old prospector found him running wild along Bright Angel Creek, that tumbles down the north wall of the canyon into the Colorado River. The prospector roped and gentled him, but then he gave him his freedom! Instead of hobbles or pickets, he held onto him by the invisible cord of friendship—flapjacks shared, and small talk around the campfire, and a warm hand scratching the itchy places on his back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In return, the burro carried the prospector’s pick and pan and even packed water for him. The rest of the time was his own. He was free to browse or to splash in the creek, or just to sit, dog-fashion, dozing in the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the prospector died, Brighty became a wild spirit again. He migrated like a bird. In winter, all alone, he roamed the warm inner reaches of the canyon where snow never falls. But in summer he hightailed it to the rim, to live in the cool mountain meadows of the Kaibab Forest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon men began using the trail he made—explorers and rangers, artists and tourists. Brighty greeted them with hearty brays, took potluck with them, and enjoyed their company; that is, until they tried to hobble him. Then he went bounding off, heehawing at their foolishness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But in spite of this—or perhaps because of it—men loved him, respected him, and envied him. He became their symbol of a joyous way of life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Brighty, then, my gratefulness for luring me to the Grand Canyon. May his wild, free spirit forever call men to his haunts. And on still summer nights may they hear, as I did, his faraway voice singing to the moon.")])]), _c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M. H.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617c3d04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fore.vue
// module id = 66
// module chunks = 0